import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import './assets/fonts/icons.js'
import router from './router'
import store from './store'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/style/style.scss'
import './services/GlobalVariables'
import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/dist/geosearch.css";
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueToggles from 'vue-toggles';
import Loading from 'vue-loading-overlay';
import {VueEditor} from "vue2-editor";
import FullCalendar from 'vue-full-calendar';
Vue.use(FullCalendar)
import VueSignaturePad from 'vue-signature-pad';
import VueGoodTablePlugin from 'vue-good-table';
import pdfMakeModule from 'pdfmake/build/pdfmake';
import pdfFontsModule from 'pdfmake/build/vfs_fonts';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// import the styles
import 'vue-good-table/dist/vue-good-table.css'

import Datatable from 'vue2-datatable-component';
import 'vue2-datatable-component/dist/min.css';
import 'vue2-datatable-component/dist/min.js';

Vue.use(Datatable);
Vue.use(BootstrapVue);

Vue.use(VueSignaturePad);

Vue.use(pdfMakeModule);
Vue.use(pdfFontsModule);

// Import stylesheet
Vue.use(VueGoodTablePlugin);
import DrawerLayout from 'vue-drawer-layout'
import 'vue-loading-overlay/dist/vue-loading.css';
import VueHorizontalTimeline from "vue-horizontal-timeline";

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

import '@js-joda/core'
import VueCal from 'vue-cal'
import gallery from 'img-vuer'


Vue.use(gallery, {
  swipeThreshold: 150, // default 100
  isIndexShow: true, // show image index, default true

})


Vue.component('vue-cal',VueCal)
Vue.component('vue-editor',VueEditor)
Vue.component('v-select', vSelect)
Vue.component('loading', Loading);
Vue.component('VueToggles', VueToggles);
Vue.use(VueVirtualScroller)
Vue.use(DrawerLayout);
Vue.use(VueHorizontalTimeline);

Vue.config.productionTip = false
import OneSignalVue from 'onesignal-vue'

Vue.use(OneSignalVue);

new Vue({
  router,
  store,
  render: h => h(App),
async beforeMount(){

  if(!this.$store.getters.getDeviceId) {
  const deviceId = generateUUID();
    store.commit('setDeviceId', deviceId);
  }

  window.OneSignalDeferred = window.OneSignalDeferred || [];
  OneSignalDeferred.push(async function(OneSignal) {
    await OneSignal.init({
      appId: "575ed409-099c-4435-8739-02b1dfdba270",
          allowLocalhostAsSecureOrigin: true,
          notifyButton: {
            enable: false,
          },
          promptOptions: {
            slidedown: {
              enabled: false
            }
          }
    });
  });
  // window.OneSignalDeferred = window.OneSignalDeferred || [];
  // OneSignalDeferred.push(async function(OneSignal) {
  //   await OneSignal.init({
  //     appId: "f3deb813-cfe8-4acd-9773-8d72d96e14bb",
  //     safari_web_id: "web.onesignal.auto.271ef36b-44de-4fef-87dc-9a2f81b1418e",
  //     allowLocalhostAsSecureOrigin: true,
  //     notifyButton: {
  //       enable: false,
  //     },
  //   });
  // });

  const deviceId = this.$store.getters.getDeviceId;
  const pushSubscriptionChangeListener = async (event) => {
    if (deviceId) {
      try {
        console.log(event)
        if (event.current.token) {
          await this.$OneSignal.login(deviceId.toString());
        }
      } catch (error) {
        console.error('Error in pushSubscriptionChangeListener:', error);
      }
    }
  };
  this.$OneSignal.User.PushSubscription.addEventListener(
      "change",
      pushSubscriptionChangeListener
  );

}



  //  async beforeMount() {
  //   await this.$OneSignal.init({
  //     appId: '4761f794-23d8-4c30-ab39-04e2ef8c0040',
  //     allowLocalhostAsSecureOrigin: true
  //   });
  // },
  // async created() {
  //   // Set up subscription handling
  //   this.$OneSignal.User.PushSubscription.addEventListener('change', async (event) => {
  //     const currentUser = this.$store.getters.getCurrentUser;
  //
  //     if (currentUser && event.current.token) {
  //       try {
  //         // Set external user ID when user is logged in
  //         await this.$OneSignal.login(currentUser.id.toString());
  //
  //         // Optional: Set user properties
  //         this.$OneSignal.User.addTag('username', currentUser.Username);
  //       } catch (error) {
  //         console.error('OneSignal external ID error:', error);
  //       }
  //     }
  //   });
  // },
  // async beforeMount() {
  //   const deviceId = generateUUID();
  //   store.commit('setDeviceId', deviceId);
  //   await this.$OneSignal.init({appId: '4761f794-23d8-4c30-ab39-04e2ef8c0040'});
  //   // f3deb813-cfe8-4acd-9773-8d72d96e14bb
  //   const pushSubscriptionChangeListener = async (event) => {
  //     try {
  //       if (event.current.token) {
  //         await this.$OneSignal.login("store.getters.getDeviceId.toString()");
  //       }
  //     } catch (error) {
  //       console.error('Error in pushSubscriptionChangeListener:', error);
  //     }
  //   };
  //   this.$OneSignal.User.PushSubscription.addEventListener(
  //       "change",
  //       pushSubscriptionChangeListener
  //   );
  // },
}).$mount('#app')
